// extracted by mini-css-extract-plugin
export default {"label":"styles_label__5gwnT","checkboxGroupItems":"styles_checkboxGroupItems__CuYQP"};